import { render } from "./BildirimlerView.vue?vue&type=template&id=3b5bba9b"
import script from "./BildirimlerView.vue?vue&type=script&lang=js"
export * from "./BildirimlerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__